import { z } from "zod";
import type { Operation } from "../types";

/**
 * The consolidated Work surface's per-user read/snooze state (`inbox_state`,
 * v78) — RO-2-09, ported from `excellent/src/work/actions.ts`, a `"use
 * server"` file with no route.ts equivalent. Each op resolves the current
 * workspace + actor and upserts; the table is local-only and the client keeps
 * an optimistic overlay, so these mirror the original's best-effort semantics
 * (a pre-migration miss is swallowed, not surfaced as an error).
 */

const readBody = z.object({ itemKey: z.string().min(1) });
export type InboxReadBody = z.infer<typeof readBody>;

const readOp: Operation<void, void, InboxReadBody, { ok: true }> = {
  method: "POST",
  path: () => "/api/work/inbox/read",
  body: readBody,
  response: z.object({ ok: z.literal(true) }),
};

const readAllBody = z.object({ itemKeys: z.array(z.string().min(1)) });
export type InboxReadAllBody = z.infer<typeof readAllBody>;

const readAllOp: Operation<void, void, InboxReadAllBody, { ok: true }> = {
  method: "POST",
  path: () => "/api/work/inbox/read-all",
  body: readAllBody,
  response: z.object({ ok: z.literal(true) }),
};

const snoozeBody = z.object({ itemKey: z.string().min(1), hours: z.number().optional() });
export type InboxSnoozeBody = z.infer<typeof snoozeBody>;

const snoozeOp: Operation<void, void, InboxSnoozeBody, { ok: true }> = {
  method: "POST",
  path: () => "/api/work/inbox/snooze",
  body: snoozeBody,
  response: z.object({ ok: z.literal(true) }),
};

export const workInbox = {
  read: readOp,
  readAll: readAllOp,
  snooze: snoozeOp,
};
